export enum AccordionOpenStateEnum {
  OPEN = 'open',
  CLOSED = 'closed',
  FIRST_OPEN = 'first-open'
}
